import React from 'react'
import { Route, Routes } from "react-router-dom"
import CommunicationCreateScreen from "screens/App/CRM/Communication/CommunicationCreateScreen"
import CommunicationDetailScreen from "screens/App/CRM/Communication/CommunicationDetailScreen"
import CommunicationEditScreen from "screens/App/CRM/Communication/CommunicationEditScreen"
import CommunicationListScreen from "screens/App/CRM/Communication/CommunicationListScreen"
import NotFoundScreen from "screens/NotFoundScreen"

const CommunicationRouter = () => {
  return (
      <Routes>
          <Route path="create" element={<CommunicationCreateScreen />} />

          <Route path="list" element={<CommunicationListScreen />} />

          <Route path=":id/detail" element={<CommunicationDetailScreen />} />

          <Route path=":id/edit" element={<CommunicationEditScreen />} />

          <Route path="*" element={<NotFoundScreen />} />

      </Routes>
  )
}

export default CommunicationRouter